'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _reactMasonryComponent = require('react-masonry-component');

var _reactMasonryComponent2 = _interopRequireDefault(_reactMasonryComponent);

var _reactHelmet = require('react-helmet');

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _components = require('components');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Profile = (_dec = (0, _reactRedux.connect)(function (state) {
  console.log(state);
  return { users: state.user, user: state.auth.user, username: state.routing.locationBeforeTransitions.pathname.replace('u/@', '').replace('@', '').replace('/', '') };
}), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(Profile, _Component);

  function Profile(props) {
    (0, _classCallCheck3.default)(this, Profile);

    var _this = (0, _possibleConstructorReturn3.default)(this, (0, _getPrototypeOf2.default)(Profile).call(this, props));

    _this.state = {
      layoutComplete: false
    };
    return _this;
  }

  (0, _createClass3.default)(Profile, [{
    key: 'render',
    value: function render() {
      var styles = require('./Profile.scss');
      var _props = this.props;
      var user = _props.user;
      var users = _props.users;
      var username = _props.username;

      console.log(user);
      var userInfo = user && user.username == username ? user : {};
      console.log('render profile: ');
      console.log(username);
      console.log(users);
      console.log(userInfo);
      var outfeats = [];
      if (!users || !users[username]) {
        return _react2.default.createElement('div', null);
      } else {
        if (users[username].isLoading) {
          return _react2.default.createElement(
            'div',
            { className: styles.loading },
            _react2.default.createElement('div', { className: styles.loader }),
            _react2.default.createElement(
              'p',
              null,
              'Loading user info...'
            )
          );
        } else if (users[username].error && user.username !== username) {
          console.log(users[username]);
          return _react2.default.createElement(
            'div',
            { className: styles.empty },
            _react2.default.createElement(
              'h1',
              null,
              'Oh no.'
            ),
            _react2.default.createElement(
              'p',
              null,
              'The user you are looking for doesn\'t exist.'
            )
          );
        }
        userInfo = user.username == username ? user : users[username].user;
        outfeats = users[username].outfeats ? users[username].outfeats : [];
        console.log(users);
        console.log(outfeats);
      }

      return _react2.default.createElement(
        'div',
        { className: 'container' },
        _react2.default.createElement(_reactHelmet2.default, { title: 'Profile | ' + userInfo.username }),
        _react2.default.createElement(
          'div',
          { className: styles.informations },
          _react2.default.createElement('div', { className: styles.profilePic, style: { backgroundImage: 'url(' + userInfo.profile_picture + ')' } }),
          _react2.default.createElement(
            'h1',
            null,
            userInfo.full_name
          ),
          _react2.default.createElement(
            'h2',
            null,
            _react2.default.createElement(
              'a',
              { href: 'https://www.instagram.com/' + userInfo.username },
              '@',
              userInfo.username
            )
          )
        ),
        outfeats.length === 0 && _react2.default.createElement(
          'div',
          { className: styles.empty },
          _react2.default.createElement(
            'h1',
            null,
            'Well...'
          ),
          _react2.default.createElement(
            'p',
            null,
            userInfo.full_name,
            ' hasn\'t created any outfeat yet.'
          )
        ),
        _react2.default.createElement(
          'div',
          { className: (0, _classnames2.default)(styles.outfits, (0, _defineProperty3.default)({}, styles.isLoading, !this.state.layoutComplete)) },
          _react2.default.createElement(
            'div',
            { className: 'wrap' },
            _react2.default.createElement(
              'div',
              { className: 'grid' },
              outfeats.map(function (outfeat, index) {
                console.log(outfeat);
                if (outfeat.images) {
                  return _react2.default.createElement(
                    'div',
                    { className: 'col--1-of-4', key: outfeat.id },
                    _react2.default.createElement(_components.OutfeatPreview, { outfeat: outfeat })
                  );
                }
              })
            )
          )
        )
      );
    }
  }]);
  return Profile;
}(_react.Component), _class2.propTypes = {
  user: _react.PropTypes.object
}, _temp)) || _class);
exports.default = Profile;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/Profile/Profile.js
 ** module id = 1114
 ** module chunks = 0
 **/